import { class_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import * as react from "react";
import { newGuid } from "./fable_modules/fable-library-js.4.24.0/Guid.js";
import { isArrayLike } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { unwrap, defaultArg, toArray, some } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { empty, singleton, append, delay as delay_1, toList, exists } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { AppTranslations__get_Home, TranslationPages_Home__get_Required } from "./Shopfoo.Shared/Translations.js";
import { max } from "./fable_modules/fable-library-js.4.24.0/Double.js";
import { Cmd_ofEffect } from "./fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";

export class React {
    constructor() {
    }
}

export function React_$reflection() {
    return class_type("Shopfoo.Client.UI.React", undefined, React);
}

export function React_withKey(key, element) {
    return react.createElement(react.Fragment, {
        key: key,
    }, element);
}

export function React_withKeyAuto_2B31D457(element) {
    let copyOfStruct;
    return React_withKey(((copyOfStruct = newGuid(), copyOfStruct)).slice(undefined, 7 + 1), element);
}

function $007CReactProperty$007C_$007C(prop) {
    const matchValue = prop;
    if (isArrayLike(matchValue)) {
        const kvp = matchValue;
        return kvp;
    }
    else {
        return undefined;
    }
}

export function $007CReactKey$007C_$007C(prop) {
    let matchResult, value;
    const activePatternResult = $007CReactProperty$007C_$007C(prop);
    if (activePatternResult != null) {
        if (activePatternResult[0] === "key") {
            matchResult = 0;
            value = activePatternResult[1];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return some(value);
        default:
            return undefined;
    }
}

export function $007CReactText$007C_$007C(prop) {
    let matchResult, value;
    const activePatternResult = $007CReactProperty$007C_$007C(prop);
    if (activePatternResult != null) {
        if (activePatternResult[0] === "children") {
            matchResult = 0;
            value = activePatternResult[1];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return some(value);
        default:
            return undefined;
    }
}

export function Feliz_IReactProperty__IReactProperty_get_AsKey(prop) {
    const matchValue = prop;
    let matchResult, kvp_1;
    if (isArrayLike(matchValue)) {
        if (matchValue[0] === "key") {
            matchResult = 0;
            kvp_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return kvp_1[1];
        default:
            return undefined;
    }
}

export class GuardProps {
    constructor(criteria, value, translations, invalid) {
        this.criteria = criteria;
        this["value@58"] = value;
        this.translations = translations;
        this.invalid = invalid;
        this.len = (((this["value@58"] == null) ? 0 : this["value@58"].length) | 0);
    }
}

export function GuardProps_$reflection() {
    return class_type("Shopfoo.Client.UI.GuardProps", undefined, GuardProps);
}

export function GuardProps_$ctor_Z1D6D4866(criteria, value, translations, invalid) {
    return new GuardProps(criteria, value, translations, invalid);
}

function GuardProps__get_Invalid(_) {
    if (((_.criteria.Required && (_.len === 0)) ? true : exists((minLength) => (_.len < minLength), toArray(_.criteria.MinLength))) ? true : exists((maxLength) => (_.len > maxLength), toArray(_.criteria.MaxLength))) {
        return true;
    }
    else {
        return defaultArg(_.invalid, false);
    }
}

export function GuardProps__get_textCharCount(_) {
    return toList(delay_1(() => {
        const matchValue = _.criteria.MaxLength;
        if (matchValue != null) {
            const maxLength = matchValue | 0;
            return append(singleton(["children", `${_.len} / ${maxLength}`]), delay_1(() => ((_.len > maxLength) ? singleton(["className", "text-error"]) : empty())));
        }
        else {
            return empty();
        }
    }));
}

export function GuardProps__get_textRequired(_) {
    return toList(delay_1(() => (_.criteria.Required ? append(singleton(["children", ` (${TranslationPages_Home__get_Required(AppTranslations__get_Home(_.translations))})`]), delay_1(() => ((_.len === 0) ? singleton(["className", "text-error"]) : empty()))) : empty())));
}

export function GuardProps__get_validation(this$) {
    return toList(delay_1(() => append(GuardProps__get_Invalid(this$) ? singleton(["className", "input-error"]) : empty(), delay_1(() => append(this$.criteria.Required ? singleton(["required", true]) : empty(), delay_1(() => {
        let matchValue;
        return append((matchValue = this$.criteria.MinLength, (matchValue != null) ? singleton(["minLength", matchValue]) : (empty())), delay_1(() => {
            const matchValue_1 = this$.criteria.MaxLength;
            if (matchValue_1 != null) {
                return singleton(["maxLength", matchValue_1]);
            }
            else {
                return empty();
            }
        }));
    }))))));
}

export function GuardProps__get_value(_) {
    return ["value", _["value@58"]];
}

export function Shopfoo_Domain_Types_Errors_Guards_GuardCriteria__GuardCriteria_props_76633593(this$, value, translations, invalid) {
    return GuardProps_$ctor_Z1D6D4866(this$, value, translations, unwrap(invalid));
}

/**
 * Remove the focus on the active element.
 * Helpful to properly hide the menu after click and mouse out events.
 */
export function JS_blurActiveElement() {
    const matchValue = document.activeElement;
    if (matchValue instanceof HTMLElement) {
        const el = matchValue;
        el.blur();
    }
}

export function JS_runAfter(delay, f) {
    setTimeout(f, max(0, ~~delay));
}

export function Cmd_ofMsgDelayed(msg, delay) {
    return Cmd_ofEffect((dispatch) => {
        JS_runAfter(delay, () => {
            dispatch(msg);
        });
    });
}

